"use client";

import { motion } from "framer-motion";

import { crossfadeVariants } from "@/lib/animations";

const INGREDIENT_WIDTHS = ["w-4/5", "w-3/5", "w-full", "w-3/4", "w-2/3", "w-4/5"];

export function RecipeDetailSkeleton() {
  return (
    <motion.article
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={crossfadeVariants}
      className="mx-auto flex w-full max-w-wide-content flex-1 flex-col"
    >
      {/* Top bar */}
      <div className="flex items-center justify-between px-3 pt-4 md:px-10 md:pt-5">
        <div className="size-9 animate-pulse rounded-md bg-muted" />
        <div className="flex items-center gap-2">
          <div className="size-9 animate-pulse rounded-md bg-muted" />
          <div className="h-9 w-16 animate-pulse rounded-md bg-muted" />
        </div>
      </div>

      {/* Hero */}
      <div className="flex flex-col gap-6 px-3 pt-5 md:px-10 md:pt-10 @md:flex-row @sm:gap-8 @lg:gap-14">
        {/* Title block */}
        <div className="order-2 flex min-w-0 flex-col justify-center @md:order-1 @md:flex-1 @md:basis-0 space-y-4">
          <div className="flex flex-wrap gap-1.5">
            {Array.from({ length: 3 }, (_, i) => (
              <div key={i} className="h-6 w-16 animate-pulse rounded-full bg-muted" />
            ))}
          </div>
          <div className="space-y-2">
            <div className="h-10 w-3/4 animate-pulse rounded bg-muted" />
            <div className="h-10 w-1/2 animate-pulse rounded bg-muted" />
          </div>
        </div>

        {/* Photo */}
        <div className="order-1 min-w-0 @md:order-2 @md:flex-1 @md:basis-0 @md:max-w-[580px]">
          <div className="aspect-square w-full animate-pulse rounded-2xl bg-muted md:rounded-[18px]" />
        </div>
      </div>

      {/* Body */}
      <div className="flex flex-col gap-8 px-3 pb-16 pt-8 md:px-10 md:pt-12 @md:grid @md:grid-cols-[280px_1fr] @md:gap-14 @lg:grid-cols-[360px_1fr]">
        {/* Ingredients panel */}
        <div className="space-y-3">
          <div className="animate-pulse rounded-2xl border border-input-border bg-input-bg p-4 md:p-[22px]">
            <div className="h-6 w-28 animate-pulse rounded bg-muted mb-4" />
            <div className="space-y-3">
              {INGREDIENT_WIDTHS.map((w, i) => (
                <div key={i} className={`h-5 animate-pulse rounded bg-muted ${w}`} />
              ))}
            </div>
          </div>
        </div>

        {/* Directions */}
        <div className="min-w-0 space-y-6">
          <div className="h-4 w-24 animate-pulse rounded bg-muted" />
          {Array.from({ length: 4 }, (_, i) => (
            <div key={i} className="flex gap-4">
              <div className="h-8 w-10 animate-pulse rounded bg-muted" />
              <div className="flex-1 space-y-2">
                <div className="h-4 w-full animate-pulse rounded bg-muted" />
                <div className="h-4 w-3/4 animate-pulse rounded bg-muted" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.article>
  );
}
